import debounce from 'lodash/debounce';
import get from 'lodash/get';

import AxiosClient from 'configurations/api-client';
import { API_UPDATE_TRACKING_AUTHENTICATION } from 'constants/api-paths';

export const trackUserAuthentication = debounce(() => {
  AxiosClient.patch(API_UPDATE_TRACKING_AUTHENTICATION);
}, 1000 * 30); // Debounce until after 30 seconds

// An axios error whose request carried the session token that is current right now.
// A request still in flight when the token rotates fails for the old token and must not sign out the new one.
export const failedWithCurrentToken = (error, token) =>
  !!token && get(error, 'config.headers.Authorization') === `Bearer ${token}`;
